import { render } from "./Mental.vue?vue&type=template&id=f35bfcf0"
import script from "./Mental.vue?vue&type=script&lang=js"
export * from "./Mental.vue?vue&type=script&lang=js"

import "./Mental.vue?vue&type=style&index=0&id=f35bfcf0&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__